import OrganizationalBeaconJSON from './OrganizationalBeacon.json';

const contract = require('@truffle/contract');

export default contract({
  abi: OrganizationalBeaconJSON.abi,
});
